import { useState, useCallback, useEffect, useMemo } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-record-tour-v1';

const BASE_STEPS: Step[] = [
  {
    target: '.tabs',
    title: 'Prestaciones',
    content: 'Aquí se muestra el total de prestaciones registradas en tu historial.',
    placement: 'bottom',
    skipBeacon: true,
  },
];

const RECORD_STEPS: Step[] = [
  {
    target: '.record-search',
    title: 'Buscador de expedientes',
    content: 'Filtra prestaciones escribiendo el número de expediente o la descripción de la contingencia. Los resultados se actualizan al instante.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.btns-upon-box-container',
    title: 'Ordenar expedientes',
    content: 'Cambia el orden de los expedientes entre fecha más reciente o más antigua con un solo clic.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.container-card-link-color',
    title: 'Ficha de expediente ',
    content: 'Cada tarjeta representa una prestación.Y muestra el número de expediente y el tipo de contingencia.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.card-link-block',
    title: 'Acceder al expediente',
    content: 'Haz clic en la tarjeta para acceder al detalle completo del expediente: citas, informes médicos, documentos y gestiones asociadas.',
    placement: 'top',
    skipBeacon: true,
  },
];

export const useRecordTour = (hasRecords: boolean = false) => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const steps = useMemo<Step[]>(
    () => (hasRecords ? [...BASE_STEPS, ...RECORD_STEPS] : BASE_STEPS),
    [hasRecords],
  );

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps, handleCallback, startTour };
};
